import * as Icons from '@ant-design/icons';
import React from "react";
import { theme } from "antd";
import { getAllIconNames } from './Icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';

let allIconNames = getAllIconNames()

const Iconfont = (props) => {
    const { token: { colorPrimary } } = theme.useToken();
    const { icon,itemColor } = props;

    return (
        <>
            {
                allIconNames.antdIcons?.indexOf(icon) !== -1 ? (
                    React.createElement(Icons[icon], { ...props, style: { ...props.style, color: itemColor?itemColor:colorPrimary }, })
                ) : null
            }
            {

                allIconNames.faIcons?.indexOf(icon) !== -1 ?
                    <FontAwesomeIcon icon={fas[icon]} style={{ ...props.style, color: itemColor?itemColor:colorPrimary  }} className="ant-menu-item-icon" />
                    : null
            }
        </>
    )
}
export default Iconfont;